import { REPUB_CONFIG } from '~/vendor/cx-web/repub-config';

import { type Repub } from '~/vendor/cx-modules/types';

export const Favicon = ({ repub, resourcesUrl }: { repub: Repub; resourcesUrl: string }) => {
  const faviconPath = `${resourcesUrl}/assets/img/`;
  const faviconFile = REPUB_CONFIG[repub]?.favicon || 'oc-favicon.svg';
  const favicon = `${faviconPath}${faviconFile}`;

  return (
    <>
      <link as="image" href={favicon} key={`preload-${favicon}`} rel="preload" />
      <link href={favicon} key={`icon-${favicon}`} rel="icon" />
    </>
  );
};
